module.exports = __webpack_public_path__ + "img/star-fill.73420b06.svg";